import React, { useState } from 'react';
import FinanceNav from './components/FinanceNav';
import FinanceDashboard from './components/FinanceDashboard';
import PaymentCenter from './payments/PaymentCenter';
import VendorManagement from './vendor/VendorManagement'; // Assuming path is correct
import PurchaseCenter from './purchases/PurchaseCenter'; // Assuming path is correct
import ExpenseCenter from './expenses/ExpenseCenter';      // --- NEW: Imported the ExpenseCenter

export default function FinanceModule({ userProfile, appId }) {
    const [financeView, setFinanceView] = useState('dashboard');

    // Access control check remains the same
    if (userProfile?.role !== 'Admin' && userProfile?.department !== 'Finance') {
        return (
            <div className="text-center p-8 bg-white rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-red-600">Access Denied</h2>
                <p className="mt-2 text-gray-600">
                    You do not have the required permissions to view the Finance Center.
                </p>
            </div>
        );
    }

    // The component router logic
    let currentViewComponent;
    switch (financeView) {
        case 'vendors':
            currentViewComponent = <VendorManagement appId={appId} userProfile={userProfile} />;
            break;
        case 'payments':
            currentViewComponent = <PaymentCenter userProfile={userProfile} appId={appId} />;
            break;
        case 'purchases':
            currentViewComponent = <PurchaseCenter userProfile={userProfile} appId={appId} />;
            break;
        // --- NEW: Case to render the ExpenseCenter component ---
        case 'expenses':
            currentViewComponent = <ExpenseCenter userProfile={userProfile} appId={appId} />;
            break;
        case 'dashboard':
        default:
            currentViewComponent = <FinanceDashboard setFinanceView={setFinanceView} />;
            break;
    }

    return (
        <div>
            {/* --- MODIFIED: The Nav is now hidden on the dashboard view for a cleaner look --- */}
            {financeView !== 'dashboard' && (
                <div className="mb-6">
                    <FinanceNav activeView={financeView} setFinanceView={setFinanceView} />
                </div>
            )}
            <div className={financeView !== 'dashboard' ? 'mt-6' : ''}>
                {currentViewComponent}
            </div>
        </div>
    );
}